import React, { useState } from "react"
import { AdminExisitingUser } from "./existing-user/existing-user.component"
import { AdminInviteUser } from "./invite/invite.component"
import { getCookie, isAuth, signOut } from "../../helper/auth"
import Button from "../atoms/button.atom"
import { useNavigate } from "react-router-dom"
import { EndpointConfig, RoutesConfig } from "../../config"
import { axiosInstance } from "../../lib/axios"
function Admin() {
	const navigation = useNavigate()

	React.useEffect(() => {
		if (!isAuth() || isAuth().role !== "Admin") {
			navigation(RoutesConfig.UserLogin)
		}
	}, [])

	const logout = async () => {
		const token = getCookie("token")
		await axiosInstance.post(
			EndpointConfig.Logout,
			{},
			{
				headers: {
					Authorization: `Bearer ${token}`
				},
				withCredentials: true
			}
		)
		signOut()
		navigation(RoutesConfig.UserLogin)
	}

	const [screenId, setScreenId] = useState("INVITE_PAGE")

	return (
		<div className="flex flex-col h-full">
			<div className="flex flex-row items-center text-gray-500 bg-white shadow" key="nav">
				<div className="p-2">
					<img className="h-10" src="../../logo.png" alt="Logo" />
				</div>
				<div className="flex flex-row flex-1 h-10 mx-4 ">
					{[
						{ id: "INVITE_PAGE", text: "Invite User" },
						{ id: "EXISTING_USER", text: "Existing User" }
					].map((screen) => {
						return (
							<div
								key={screen.id}
								onClick={() => setScreenId(screen.id)}
								className={`text-sm border-0  hover:bg-blue-200  cursor-pointer text-md whitespace-nowrap flex justify-center items-center ${
									screenId === screen.id
										? "border-b-2  bg-blue-100 border-blue-500"
										: "border-blue-200"
								}`}
							>
								<span className="px-4">{screen.text}</span>
							</div>
						)
					})}
				</div>
				<div className="px-2 text-sm font-bold">
					<Button onClick={() => logout()}>Logout</Button>
				</div>
			</div>
			<div className="flex-1 w-full p-4">
				{screenId === "INVITE_PAGE" && <AdminInviteUser />}
				{screenId === "EXISTING_USER" && <AdminExisitingUser />}
			</div>
		</div>
	)
}

export default Admin
